// extracted by mini-css-extract-plugin
export default {"login":"Login_login__QdBJ0","wrapper":"Login_wrapper__p24gH","footer":"Login_footer__cDApO","img":"Login_img__ucFiI"};